import Modal from "react-bootstrap/Modal";

export default function InternalError (props)
{
    // TODO : disable errors !!
    return (
	<Modal
	    show={props.show}
	    contentClassName="shadow"
	    backdrop="static"
	    keyboard={false}
	    centered
	>
	    <Modal.Header>
		<Modal.Title>Erreur interne</Modal.Title>
	    </Modal.Header>
	    <Modal.Body>
		<p>
		    Une erreur est survenue sur nos serveurs.
		    Veuillez rafraîchir la page et reprendre où vous en étiez.
		</p>
		<p>Si l'erreur persiste, veuillez nous contacter à l'adresse suivante :</p>
		<p className="text-center"><a href="mailto:contact@legamelab.com">contact@legamelab.com</a></p>
		{/* <p>Erreur :</p>
		    <span dangerouslySetInnerHTML={{__html: props.error}}/> */}
	    </Modal.Body>
	</Modal>
    );
}
